<template>
  <div>
    <div class="banner">
      <div>
        <div class="title">测评数据集</div>
        <div class="update-time">更新时间：{{ updateTime }}</div>
        <div class="des">
          涵盖中英文两种语言，选择和问答两种题型，已累计评测题目近5万道。覆盖多个安全领域，包括安全管理、数据安全、网络与基础架构安全、安全标准与法规、应用安全、身份与访问控制、基础软硬件与技术、端点与主机安全、云安全等，全方位量化大模型在网络安全领域知识记忆、逻辑推理能力。
          <div>
            部分数据已开源：
            <el-link
              type="primary"
              href="https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/secbench.zip"
              :underline="false"
            >
              点击下载
            </el-link>
          </div>
        </div>
      </div>
    </div>
    <div class="flex dataset-list">
      <div class="advantage-content" v-for="(item, index) in dataset" :key="item._auto_id">
        <div class="advantage-sub-title">{{ item.dataset_name }}</div>
        <div class="flex f12 dataset-info">
          <div class="flex">
            <el-tag class="tag" v-for="(type, idx) in item.data_type" :key="idx">
              {{ type }}
            </el-tag>
            <span class="dataset-tips dataset-divider">|</span>
            <span class="dataset-tips">约 {{ item.count }} 题</span>
          </div>
        </div>
        <div class="dataset-des">{{ item.introduction }}</div>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <!--el-dialog :title="curDataset.dataset_name" :visible.sync="datasetVisible" width="30%">
      <json-viewer :value="{ data: curDataset.data_example }" :expand-depth="5" copyable>
      </json-viewer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="datasetVisible = false" size="small" class="dataset-btn">
          关闭
        </el-button>
      </span>
    </el-dialog-->
  </div>
</template>

<script>
// import index from '@/config/index';
import { doHttp } from '@/common/simple_http';
import JsonViewer from 'vue-json-viewer';

export default {
  components: {
    JsonViewer,
  },
  data() {
    return {
      dataset: [],
      curDataset: {},
      datasetVisible: false,
      updateTime: '',
    };
  },
  created: function () {
    this.getDataset();
  },
  mounted() {},
  methods: {
    getDataset() {
      doHttp('/data/getOtherInfo', 'post', { group: 'Dataset_Infos' }, (rst) => {
        rst.data.sort((n1, n2) => {
          return parseInt(n2.count) - parseInt(n1.count);
        });
        this.dataset = rst.data.map((item) => {
          // item.data_example = JSON.parse(item.data_example);
          item.data_type = item.data_type.split(';');
          this.updateTime > item._rainbow_update_time
            ? ''
            : (this.updateTime = item._rainbow_update_time);
          return item;
        });
      });
    },
    /* open(idx) {
      this.curDataset = this.dataset[idx];
      this.datasetVisible = true;
    }, */
  },
};
</script>

<style lang="less" scoped>
// 使用通用的 less 变量和 mixin 方法
@import '~@/assets/styles/_var.less';
@import '~@/assets/styles/_mixin.less';

.banner {
  margin-top: 48px;
  width: 100%;
  height: 396px;
  background: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/dataset_banner.png)
      center center / 1920px 396px no-repeat,
    linear-gradient(102deg, rgb(222, 232, 241) 0%, rgb(221, 231, 240) 100%);
  & > div {
    width: @width;
    height: 100%;
    margin: auto;
    .title {
      font-family: TencentSans;
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      padding-top: 57px;
    }
    .update-time {
      color: rgba(82, 92, 114, 0.5);
      line-height: 21px;
      padding-top: 22px;
    }
    .des {
      width: 680px;
      line-height: 22px;
      color: rgba(82, 92, 114, 0.9);
      padding-top: 13px;
    }
  }
}
.dataset-list {
  width: @width;
  flex-wrap: wrap;
  //.justify-content(space-between);
  margin: -100px auto 0 auto;
  & > div {
    margin-right: 20px;
    &:nth-of-type(3n) {
      margin-right: 0;
    }
    width: 380px;
    margin-bottom: 25px;
    height: 210px;
    padding: 24px 20px;
    box-shadow: -8px -8px 20px 0px rgb(255, 255, 255), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
    border: 2px solid #fff;
    background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%), linear-gradient(0deg, #fff, #fff);
  }
}
.tag {
  background: rgba(219, 232, 255, 1);
  padding: 0 8px;
  margin-right: 8px;
  border: none;
  border-radius: 0;
  color: @color-primary;
  height: 20px;
  line-height: 20px;
}
.dataset-tips {
  color: #aaa;
  line-height: 20px;
}
.dataset-divider {
  padding: 0 10px;
}
.show-data {
  color: @color-primary;
  line-height: 20px;
  cursor: pointer;
}
.dataset-info {
  .justify-content(space-between);
  padding: 20px 0 10px 0;
}
/deep/.dataset-des {
  width: 100%;
  text-align: left;
  color: #848c9b;
  font-weight: 400;
  width: 100%;
  line-height: 22px;
  word-wrap: break-word;
}
/deep/.el-dialog__footer {
  text-align: center;
}
.el-button--primary {
  background-color: @color-primary;
  border-color: @color-primary;
}
.dataset-btn {
  width: 88px;
}
.divider {
  width: @width;
  background: #dfe5ef;
  margin: 20px auto 0 auto;
}
</style>
